import { render } from "./DiversionIcon.vue?vue&type=template&id=27a0ec2b"
import script from "./DiversionIcon.vue?vue&type=script&lang=js"
export * from "./DiversionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__